// actions/door/save.js

import { attachAuth } from '../../utils/authService';
import PubSub         from 'pubsub-js';

export function saveHasErrored(bool) {
  return {
    type: 'SAVE_DOOR_HAS_ERRORED',
    hasErrored: bool
  };
}

export function saveIsLoading(bool) {
  return {
    type: 'SAVE_DOOR_IS_LOADING',
    isLoading: bool
  };
}

export function saveFetchDataSuccess(resp) {
  return {
    type: 'SAVE_DOOR_FETCH_DATA_SUCCESS',
    resp
  };
}

export function saveFetchData(host, body) {
  return (dispatch) => {
    dispatch(saveIsLoading(true));
    dispatch(saveHasErrored(false));
    fetch(host + 'door/save', {
      method: 'post',
      body: JSON.stringify(body),
      headers: attachAuth()
    }).then(promise => {
      if (!promise.ok) {
        throw Error(promise.statusText);
      }
      
      dispatch(saveIsLoading(false));
      promise.json()
        .then(result => {
          dispatch(saveFetchDataSuccess(result))
          PubSub.publish('onboarding.door.save', result);
        })
        .catch((e) => {
          console.log(e);
          dispatch(saveHasErrored(true))
        });
      })
      .catch((e) => {
        console.log(e);
          dispatch(saveHasErrored(true))
      });
  };
}